import React from 'react'
import Marquee from 'react-fast-marquee'
import logo1 from '../assets/appleLogo.png'
import logo2 from '../assets/awsLogo.png'
import logo3 from '../assets/uberLogo.png'
import logo4 from '../assets/logos_google.png'
import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons'

const Customers = () => {

  return (
    <>
    <div className='bg-[#282828] min-h-[50vh] bg-center bg-cover flex justify-center items-center'>
      <div className='text-center'>
        <h1 className='text-3xl font-bold text-white pt-20 leading-none tracking-tight text-gradient'>
          Customers
        </h1>
        <p className='pt-9 text-4xl text-white'>
          BRANDS WE'VE WORKED WITH
        </p>
      </div>

      </div>
      <div className='pb-32'>
      <Marquee pauseOnHover speed={150} gradient={false} style={{backgroundColor:'none'}}>
    <div>
  <img src={logo1} alt="" className='image_wrapper' />
  </div>
  <div>
  <img src={logo2} alt="" className='image_wrapper'/>
  </div>
  <div>
  <img src={logo3} alt="" className='image_wrapper' />
  </div>
  <div>
  <img src={logo4} alt="" className='image_wrapper'/>
  </div> 
  <div>
  <img src={logo1} alt="" className='image_wrapper' />
  </div>
  <div>
  <img src={logo2} alt="" className='image_wrapper'/>
  </div>
  <div>
  <img src={logo3} alt="" className='image_wrapper' />
  </div>
  <div>
  <img src={logo4} alt="" className='image_wrapper'/>
  </div> 
   </Marquee>
   </div>
   </>
   
  )
}

export default Customers

